import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../data/entitlement/outOfScopeCases/initialState.batchUpdate.data';



const BatchUpdateSlice = createSlice({
  name: 'batchUpdate',
  initialState,
  reducers: {
    resetValues: () => initialState,
    addData: (state, action) => {
     state.rowArray[action?.payload?.currentPage]=action?.payload?.data;
    },
    
    handleRowArray: (state) => {
      state.rowArray=[];
     },
  },
  extraReducers: (builder) => {
    builder      
  },
});

export const {
    addData,
    handleRowArray,
    resetValues
 
} = BatchUpdateSlice.actions;
export default BatchUpdateSlice.reducer;
